import { Digtective } from '..';

export function getToken(facade: Digtective) {
  const { token } = facade.options ?? {};
  return `Bearer ${token}`;
}
